import { ReactNode } from "react";

import TextButton from "client/common/components/buttons/TextButton";

import styles from "../styles/AppliedFilters.module.less";

type AppliedFiltersProps = {
  children: ReactNode;
  /** Passed explicitly because the row cannot tell whether its children rendered anything. */
  hasSelectedFilters: boolean;
  onClearAll: () => void;
};

const AppliedFilters = ({ children, hasSelectedFilters, onClearAll }: AppliedFiltersProps) => {
  if (!hasSelectedFilters) {
    return null;
  }

  return (
    <div className={styles.row}>
      {children}
      <TextButton type="button" className={styles.clearAll} onClick={onClearAll}>
        Clear all
      </TextButton>
    </div>
  );
};

export default AppliedFilters;
